import { ClientPage } from './pages/client/client.page';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { MaterialModule } from './module/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { CommonModule } from '@angular/common';
import { SentryErrorHandler } from './helpers/sentry.ErrorHandler';
import { CookieService } from 'ngx-cookie-service';
import { LoginComponent } from './login/login.component';
import { ProgressSpinnerComponent } from './spinner/spinner.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { AutofocusDirective } from './directive/matinput.directive';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { PopoverComponent } from './components/popover/popover.component';
import { SharedModule } from './components/sharedComponents/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { AdministrationPage } from './pages/administration/administration.page';
import { CartPage } from './pages/cart/cart.page';
import { CartdetailsPage } from './pages/cartdetails/cartdetails.page';
import { ForgetpasswordPage } from './pages/forgetpassword/forgetpassword.page';
import { HomePage } from './pages/home/home.page';
import { PointofsalePage } from './pages/pointofsale/pointofsale.page';
import { PointofsaledetailsPage } from './pages/pointofsaledetails/pointofsaledetails.page';
import { TransactionPage } from './pages/transaction/transaction.page';
import { UserPage } from './pages/user/user.page';
import { TranslateSlice } from './pipe/translateSlice';
import { TransactiondetailsPage } from './pages/transactiondetails/transactiondetails.page';
import { NgChartsModule } from 'ng2-charts';
import { HotToastModule } from '@ngneat/hot-toast';
import { ClientEditPage } from './pages/client/modal/clientedit/clientedit.page';
import { UserEditPage } from './pages/user/useredit/useredit.page';
import { ReseauPage } from './pages/reseau/reseau.page';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MapComponent } from './pages/map/map.page';
import { FrenchDecimalPipe } from './pipe/frenchDigit';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorI18n } from './utils/paginatorI18n';
import { FrenchDecimalPipe2 } from './pipe/frenchDigit';
import { TestPage } from './pages/test/test.page';
@NgModule({
  declarations: [
    LoginComponent,
    ProgressSpinnerComponent,
    AppComponent,
    AutofocusDirective,
    PopoverComponent,
    HomePage,
    AdministrationPage,
    ForgetpasswordPage,
    PointofsalePage,
    PointofsaledetailsPage,
    TransactionPage,
    TransactiondetailsPage,
    CartPage,
    CartdetailsPage,
    UserPage,
    ClientPage,
    TranslateSlice,
    FrenchDecimalPipe,
    ClientEditPage,
    UserEditPage,
    ReseauPage,
    MapComponent,
    FrenchDecimalPipe2,
    TestPage
  ],
  imports: [
    HotToastModule.forRoot({
      position: 'top-right',
      reverseOrder: false,
    }),
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    // ngx-translate and the loader module
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    TranslateModule ,
    NgIdleKeepaliveModule.forRoot(),
    IonicModule.forRoot(),
    SharedModule,
    NgxPaginationModule,
    NgChartsModule,
    FontAwesomeModule
  ],
  providers: [
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: MatPaginatorIntl, deps: [TranslateService],
      useFactory: (translateService: TranslateService) => new PaginatorI18n(translateService).getPaginatorIntl()
    }
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
